'use client';

import { EmptyState } from '@yanolja-rnd/nol-design-system';
import { useHashModalAppRouter } from '@weberus/next-libs/feature/hash-modal-app-router';
import { generateHashedId } from '@weberus/utils';
import { MODAL__SWIPE_BACK__OPTION } from '@weberus/ui/utils/swipe-back-options';
import { useResetFilterWithQuery } from '@/app/_components/feature/global-filter-modal/hooks/use-reset-filter-with-query';
import { GlobalFilterModalHashId } from '@/app/_components/feature/global-filter-modal/utils/constants';

export const NoFilterResult = () => {
  const { resetFilterWithQuery } = useResetFilterWithQuery();
  const [_, setIsGlobalFilterOpen] = useHashModalAppRouter({
    id: `hash-${generateHashedId(GlobalFilterModalHashId)}`,
    swipeBackOption: MODAL__SWIPE_BACK__OPTION,
  });

  const handleFilterChange = () => {
    setIsGlobalFilterOpen(true);
  };

  const handleClearFilter = () => {
    resetFilterWithQuery();
  };

  return (
    <div className="mt-40 flex h-full w-full justify-center bg-colors-white">
      <EmptyState
        title="조건에 맞는 상품이 없어요"
        description="필터를 변경하거나 초기화해 보세요."
        pcType="pcLegacySize"
        buttons={[
          {
            content: '필터 변경하기',
            onClick: handleFilterChange,
          },
          {
            content: '필터 초기화하기',
            onClick: handleClearFilter,
          },
        ]}
      />
    </div>
  );
};
